import { RecordEquipmentSummaryPanel } from "#batteries-included-components/Panels/SummaryPanels/RecordEquipmentSummaryPanel";
import { RecordValueTablePanel } from "#src/batteries-included-components/Panels/TablePanels/RecordValueTablePanel";
import { useActionDetails } from "#src/components/hooks/useActionDetails";
import {
  EquipmentContext,
  EquipmentProvider,
} from "#src/contexts/EquipmentContext";
import { RecordContext, RecordProvider } from "#src/contexts/RecordContext";
import { useBreadcrumbsFromRoute } from "#src/utils/route";
import { Page, Pill, PillProps } from "@validereinc/common-components";
import { getRecordStatusFromValues } from "@validereinc/domain";
import { yearMonthName } from "@validereinc/utilities";
import React, { useContext } from "react";
import { EquipmentRecordDetailRoutePath } from ".";

const EquipmentRecordDetailPageContent = () => {
  const { equipment } = useContext(EquipmentContext) ?? {};
  const { record } = useContext(RecordContext) ?? {};

  const lockStatus = record?.values
    ? getRecordStatusFromValues(record.values)
    : "";

  const recordStatusOptions: Record<
    string,
    { label: string; variant: PillProps["variant"] }
  > = {
    locked: { label: "Locked", variant: "default" },
    partially_locked: { label: "Partially Locked", variant: "info" },
    unlocked: { label: "Unlocked", variant: "info" },
  };

  const pageTitle = record
    ? `${yearMonthName(record.year_month)} Record`
    : EquipmentRecordDetailRoutePath.title;

  const updateInfo = useActionDetails({
    type: "edit",
    date: record?.updated_at,
    byUserId: record?.updated_by,
  });

  const [breadcrumbs] = useBreadcrumbsFromRoute(
    EquipmentRecordDetailRoutePath,
    {
      "/:equipmentId/detail": {
        title: equipment?.name,
      },
      "/:recordId": {
        title: pageTitle,
      },
    }
  );

  return (
    <Page
      category={EquipmentRecordDetailRoutePath.previous?.title}
      breadcrumbs={breadcrumbs}
      title={
        !record ? (
          pageTitle
        ) : (
          <>
            {pageTitle}&nbsp;
            {lockStatus ? (
              <Pill
                variant={recordStatusOptions[lockStatus].variant}
                hasDot={false}
              >
                {recordStatusOptions[lockStatus].label}
              </Pill>
            ) : null}
          </>
        )
      }
      renderMeta={
        !updateInfo.description
          ? undefined
          : ({ MetaSegments }) => (
              <MetaSegments values={[updateInfo.description]} />
            )
      }
    >
      <RecordEquipmentSummaryPanel />
      <RecordValueTablePanel />
    </Page>
  );
};

export const EquipmentRecordDetailPage = () => (
  <EquipmentProvider>
    <RecordProvider>
      <EquipmentRecordDetailPageContent />
    </RecordProvider>
  </EquipmentProvider>
);
